/**
 * The fields a text may carry (D-66, D-171) — {{account.name}}, {{offer.valid_until}}, the offer's
 * own fields set in Settings as {{cf.<key>}} … — named for people and grouped for the menus that
 * insert them. Core fills them in (Placeholders): in the editor, in every print, in catalogue
 * texts once in an offer.
 */
import { te } from '@/i18n/index.js'

export const PLACEHOLDER_KEYS = [
  'offer.number', 'offer.title', 'offer.date', 'offer.valid_until', 'offer.applications', 'offer.configuration', 'offer.configuration_of', 'offer.device_of', 'offer.site_survey', 'opportunity.name',
  // The party's address is its registered office's; each address role has its own field (D-198).
  'account.name', 'account.tax_id', 'account.address', 'account.address.correspondence', 'account.address.headquarters', 'account.address.invoice', 'account.address.delivery',
  'contact.full_name', 'contact.first_name', 'contact.last_name', 'contact.job_title', 'contact.phone', 'contact.email',
  'end_customer.name', 'end_customer.tax_id', 'end_customer.address', 'site.address',
  'user.name', 'user.email', 'user.phone', 'user.job_title',
  'our.name', 'our.job_title', 'our.phone', 'our.email',
]
const GROUPS = ['offer', 'opportunity', 'account', 'contact', 'end_customer', 'site', 'user', 'our', 'terms', 'company', 'cf', 'param', 'component']

/** Every field: the fixed ones, the offer's own fields, and those given (e.g. a catalogue text's own). */
export function placeholderKeys(meta, extra = [], known = null) {
  const own = (meta?.customFields?.('offer') || []).map((f) => `cf.${f.key}`)
  return [...new Set([...(known || PLACEHOLDER_KEYS), ...own, ...extra])]
}

/** A field's name for people: its group, then what it is. */
export function placeholderLabel(key, t, meta) {
  const [group, ...rest] = String(key).split('.')
  const name = rest.join('.')
  const groupLabel = GROUPS.includes(group) ? t(`placeholders.groups.${group}`) : group
  if (group === 'cf') {
    const field = meta?.customField?.('offer', name)
    return { group: groupLabel, name: field ? meta.localized(field.label) : name }
  }
  const own = `placeholders.keys.${key.replace(/\./g, '__')}`
  return { group: groupLabel, name: te(own) ? t(own) : name.replace(/_/g, ' ') }
}

/** The fields as addictive-richtext takes them (its FieldsMenu, its right-button menu): [{key, name, group}]. */
export function placeholderFields(keys, t, meta) {
  return keys.map((key) => ({ key, ...placeholderLabel(key, t, meta) }))
}
